/* eslint-disable no-underscore-dangle */

import L from 'leaflet';

const SVG_RELOAD = '/maps-buttons/reload.svg';
const SVG_STYLE = 'width:100%; height:100%;';
const CONTAINER_STYLE = `
  position: relative;
  cursor: pointer;
  height: 34px;
  width: 34px;
`;

L.Control.ReloadButton = L.Control.extend({
  options: {
    position: 'topleft',
    reloadFunction: null
  },

  onAdd(map) {
    // eslint-disable-next-line no-param-reassign
    map.reloadButton = this;
    const container = L.DomUtil.create('div');
    const svg = L.DomUtil.create('img');
    const { options } = this;
    this._map = map;
    this.setOptions(options);

    container.title = 'Refrescar';
    container.style.cssText = CONTAINER_STYLE;
    svg.src = SVG_RELOAD;
    svg.style = SVG_STYLE;

    L.DomEvent.disableClickPropagation(container);

    L.DomEvent.on(container, 'click', options.reloadFunction, this);
    container.appendChild(svg);
    return container;
  },
  setOptions(opts) {
    const { options } = this;
    if (opts.reloadFunction) {
      options.reloadFunction = opts.reloadFunction;
    }
  }
});

L.control.reloadbutton = opts => new L.Control.ReloadButton(opts);

/**
 * Reloads the layer or the map view (layers and basemap).
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {object} reloadFunction - The function to reload the layer/map.
 */
const customReloadButton = (leafletMap, reloadFunction) => {
  L.control.reloadbutton({ reloadFunction }).addTo(leafletMap);
};

export default customReloadButton;
